import React, { lazy } from "react";

const LazyAudits = lazy(() => import("./Audits"));

const Audits = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAudits {...props} />;

export default Audits;
